var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnemployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25987_3982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.894531,
    y: 0.8125,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25987_3982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8942 14.8125C12.9831 14.8125 13.0609 14.7791 13.1275 14.7125C13.1942 14.6458 13.2275 14.568 13.2275 14.4791C13.2275 14.3903 13.1942 14.3125 13.1275 14.2458C13.0609 14.1791 12.9831 14.1458 12.8942 14.1458C12.8053 14.1458 12.7275 14.1791 12.6609 14.2458C12.5942 14.3125 12.5609 14.3903 12.5609 14.4791C12.5609 14.568 12.5942 14.6458 12.6609 14.7125C12.7275 14.7791 12.8053 14.8125 12.8942 14.8125ZM12.5609 13.4791H13.2275V10.8125H12.5609V13.4791ZM3.56087 14.8125C3.19421 14.8125 2.88032 14.6819 2.61921 14.4208C2.35809 14.1597 2.22754 13.8458 2.22754 13.4791V6.14581C2.22754 5.77915 2.35809 5.46526 2.61921 5.20415C2.88032 4.94304 3.19421 4.81248 3.56087 4.81248H6.22754V3.47915C6.22754 3.11248 6.35809 2.79859 6.61921 2.53748C6.88032 2.27637 7.19421 2.14581 7.56087 2.14581H10.2275C10.5942 2.14581 10.9081 2.27637 11.1692 2.53748C11.4303 2.79859 11.5609 3.11248 11.5609 3.47915V4.81248H14.2275C14.5942 4.81248 14.9081 4.94304 15.1692 5.20415C15.4303 5.46526 15.5609 5.77915 15.5609 6.14581V8.99581C15.3609 8.85137 15.1498 8.72637 14.9275 8.62081C14.7053 8.51526 14.472 8.42359 14.2275 8.34581V6.14581H3.56087V13.4791H8.27754C8.31087 13.7125 8.36087 13.9403 8.42754 14.1625C8.49421 14.3847 8.57754 14.6014 8.67754 14.8125H3.56087ZM7.56087 4.81248H10.2275V3.47915H7.56087V4.81248ZM12.8942 16.1458C11.972 16.1458 11.1859 15.8208 10.5359 15.1708C9.88587 14.5208 9.56087 13.7347 9.56087 12.8125C9.56087 11.8903 9.88587 11.1041 10.5359 10.4541C11.1859 9.80415 11.972 9.47915 12.8942 9.47915C13.8164 9.47915 14.6025 9.80415 15.2525 10.4541C15.9025 11.1041 16.2275 11.8903 16.2275 12.8125C16.2275 13.7347 15.9025 14.5208 15.2525 15.1708C14.6025 15.8208 13.8164 16.1458 12.8942 16.1458Z",
    fill: "#63666A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnemployment);
export default __webpack_public_path__ + "static/media/Unemployment.3cdf3e86052b32e2614bd8fbf35b2f42.svg";
export { ForwardRef as ReactComponent };